import React from "react";

const Header = ({ currentPage }) => {
  return (
    <div className="app-v2-header-wrapper has-extra">
      <div className="app-v2-header-left">
        <span className="app-v2-header-title">
          Danh sách khách hàng
        </span>
      </div>
      {/* {currentPage && currentPage === "customer" ? (
        <div className="app-v2-header-extra-wrapper">
          <div className="app-v2-header-extra-item">
            <div>
              <button
                type="button"
                className="app-btn app-btn-primary btn-import-audience"
              >
                <div
                  className="svg-next-icon"
                  style={{
                    backgroundColor: "rgb(255, 255, 255)",
                    maskImage:
                      "url('https://static.harasocial.com/svg-funnel/ic-upload.svg')",
                    maskRepeat: "no-repeat",
                    maskSize: "18px 18px",
                    width: "18px",
                    height: "18px",
                  }}
                ></div>
                <span>Thêm danh sách</span>
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )} */}
    </div>
  );
};

export default Header;
